/* eslint-disable no-restricted-syntax */

type MessageError = {
  key: string;
  value: string | ((matches: RegExpMatchArray) => string);
};

const DEFAULT_ERROR_MESSAGE = 'Um erro inesperado aconteceu. Tente novamente em instantes.';

export const messagesError: MessageError[] = [
  {
    key: 'Erro',
    value: 'Mensagem',
  },
];

export function responseMessage(err: unknown): string {
  const messages = normalizeErrorMessages(err);

  if (!messages.length) {
    return DEFAULT_ERROR_MESSAGE;
  }

  const translatedMessages: string[] = messages.map(translateErrorMessage);

  return translatedMessages.join(', ');
}

function normalizeErrorMessages(err: unknown): string[] {
  if (typeof err === 'string') {
    const message = err.trim();
    return message ? [message] : [];
  }

  if (Array.isArray(err)) {
    return err.flatMap(normalizeErrorMessages);
  }

  if (err && typeof err === 'object' && 'message' in err) {
    return normalizeErrorMessages((err as { message?: unknown }).message);
  }

  return [];
}

function translateErrorMessage(err: string): string {
  for (const { key, value } of messagesError) {
    const matches = err.match(key);
    if (matches) {
      return buildMessage(matches, value);
    }
  }

  return err;
}

function buildMessage(
  matches: RegExpMatchArray,
  value: string | ((matches: RegExpMatchArray) => string)
): string {
  if (typeof value === 'function') {
    return value(matches);
  }
  return value.replace(/\$(\d+)/g, (_, index) => matches[index]);
}
